import { render, staticRenderFns } from "./SwitchUserModal.vue?vue&type=template&id=79c5957f&"
import script from "./SwitchUserModal.vue?vue&type=script&lang=js&"
export * from "./SwitchUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports